import React from 'react';
import ResultPageModal from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';
import { safeCapitalizeWords } from '../../../common/constants';

function HouseModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  processingQuote,
  type,
}) {
  const getQuoteTypeNameForResCivile = () => {
    if (type.id === 'res_civile' && insuranceRequest.product.id === 11 && processingQuote !== null) {
      return safeCapitalizeWords(processingQuote.product_name);
    }

    if (type.id === 'res_civile' && insuranceRequest.product.id === 11) {
      const quote = quotations?.res_civile?.find((el) => el.company_id === 16);
      if (quote) {
        return safeCapitalizeWords(quote.product_name);
      }
      const nobisQuote = quotations?.res_civile?.find((el) => el.company_id === 1001);

      if (nobisQuote) {
        return safeCapitalizeWords(nobisQuote.product_name);
      }
    }

    return safeCapitalizeWords(type.name);
  };

  const title = type.id === 'res_civile' ? getQuoteTypeNameForResCivile() : safeCapitalizeWords(type.name);

  return (
    <ResultPageModal
      type={type}
      title={title}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
    />
  );
}

export default HouseModal;
